import { render, staticRenderFns } from "./noticeAddEdit.vue?vue&type=template&id=78c8643b&scoped=true"
import script from "./noticeAddEdit.vue?vue&type=script&lang=js"
export * from "./noticeAddEdit.vue?vue&type=script&lang=js"
import style0 from "./noticeAddEdit.vue?vue&type=style&index=0&id=78c8643b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c8643b",
  null
  
)

export default component.exports